// extracted by mini-css-extract-plugin
export default {"categories":"Categories_categories__HtPM-","images":"Categories_images__D++V6"};